import React, { useState } from "react";
import LazyLoad from "react-lazyload";
 

const ClassTabs = () => {
    // State to keep track of the active tab
    const [activeTab, setActiveTab] = useState(0);

    // Array of tab data including images and content
    const tabData = [
        {
            image: "https://webapi.entab.info/api/image/MMSKN/public/Images/pre-primary.png", // Use the imported image
            title: <>Pre primary <br /> School</>,
            content: "MMS is a strong believer and promoter of holistic all round development of its students and follows ICSE curriculum which is not only relevant to 21st century but also extremely practical and precise in its approach. MMS believes learning is an ongoing process. So that a vibrant curriculum may take the individual into the realms of co-existence with the immediate and future environment. It makes the individual. Think! As the school is affiliated to THE COUNCIL FOR THE INDIAN SCHOOL CERTIFICATE EXAMINATIOS, New Delhi, and imparts education upto the ISC level we adhere to the curriculum",
            readMore: '/'
        },
        {
            image: "https://webapi.entab.info/api/image/MMSKN/public/Images/primary.png", // Use the imported image
            title: <>Primary <br />School</>,
            content: "MMS is a strong believer and promoter of holistic all round development of its students and follows ICSE curriculum which is not only relevant to 21st century but also extremely practical and precise in its approach. MMS believes learning is an ongoing process. So that a vibrant curriculum may take the individual into the realms of co-existence with the immediate and future environment. It makes the individual. Think! As the school is affiliated to THE COUNCIL FOR THE INDIAN SCHOOL CERTIFICATE EXAMINATIOS, New Delhi, and imparts education upto the ISC level we adhere to the curriculum",
            readMore: '/'
        },
        {
            image: "https://webapi.entab.info/api/image/MMSKN/public/Images/middle-school.png", // Use the imported image
            title: <>Middle<br /> School</>,
            content: "MMS is a strong believer and promoter of holistic all round development of its students and follows ICSE curriculum which is not only relevant to 21st century but also extremely practical and precise in its approach. MMS believes learning is an ongoing process. So that a vibrant curriculum may take the individual into the realms of co-existence with the immediate and future environment. It makes the individual. Think! As the school is affiliated to THE COUNCIL FOR THE INDIAN SCHOOL CERTIFICATE EXAMINATIOS, New Delhi, and imparts education upto the ISC level we adhere to the curriculum",
            readMore: '/'
        },
        {
            image: "https://webapi.entab.info/api/image/MMSKN/public/Images/secondary.png", // Use the imported image
            title: <>Secondary <br />School</>,
            content: "MMS is a strong believer and promoter of holistic all round development of its students and follows ICSE curriculum which is not only relevant to 21st century but also extremely practical and precise in its approach. MMS believes learning is an ongoing process. So that a vibrant curriculum may take the individual into the realms of co-existence with the immediate and future environment. It makes the individual. Think! As the school is affiliated to THE COUNCIL FOR THE INDIAN SCHOOL CERTIFICATE EXAMINATIOS, New Delhi, and imparts education upto the ISC level we adhere to the curriculum",
            readMore: '/'
        },
        {
            image: "https://webapi.entab.info/api/image/MMSKN/public/Images/senior.png", // Use the imported image
            title: <>Senior <br />School  </>,
            content: "MMS is a strong believer and promoter of holistic all round development of its students and follows ICSE curriculum which is not only relevant to 21st century but also extremely practical and precise in its approach. MMS believes learning is an ongoing process. So that a vibrant curriculum may take the individual into the realms of co-existence with the immediate and future environment. It makes the individual. Think! As the school is affiliated to THE COUNCIL FOR THE INDIAN SCHOOL CERTIFICATE EXAMINATIOS, New Delhi, and imparts education upto the ISC level we adhere to the curriculum",
            readMore: '/'
        } 
    ];

    return (
        <div className="class-tabs">
            <div className="tabs">
                {tabData.map((tab, index) => (
                    <div
                        key={index}
                        className={`tab ${activeTab === index ? "active" : ""}`}
                        onClick={() => setActiveTab(index)}
                    >
                   
                        <div className="tabs-img">
                            <LazyLoad><img src={tab.image} alt={tab.title} className="tab-image" /></LazyLoad>
                        </div>
                        <div className="tab-title">{tab.title}</div>
                    </div>
                ))}
            </div>
            <div className="tabs-content">
                <div className="content">
                  
                    <p>{tabData[activeTab].content}</p>
                    <button className="button" href={tabData.readMore}>Read More <i className="bi bi-arrow-right"></i></button>
                </div>
            </div>
        </div>
    );
};

export default ClassTabs;
